/**
 * Version Module.
 */
export const VERSION = '1.6.0'